import Button from '../../components/v2/Button/Button';
import { Modal } from '../../components/v2/Modal/Modal';
import { Typography } from '../../components/v2/Typography/Typography';
import { usePCO } from '../../provider/pcoProvider';

const PCOInfoModal = () => {
  const {
    pcoInfoModalOpen,
    setPcoInfoModalOpen,
    setPcoApplicationModalOpen,
  } = usePCO();

  const handleStart = () => {
    setPcoInfoModalOpen(false);
    setPcoApplicationModalOpen(true);
  };

  return (
    <Modal
      isOpen={pcoInfoModalOpen}
      onClose={() => setPcoInfoModalOpen(false)}
      showCloseButton={true}
      title={''}
    >
      <div className='max-w-[500px] flex flex-col justify-center items-center text-center'>
        <Typography type='display-100' className='max-w-[436px] mt-6'>
          Please prepare all the paperwork you need assistance with prior to
          filling out this form!
        </Typography>
        <Typography
          type='body-400'
          variant='functional-low'
          className='mt-6 max-w-[436px]'
        >
          We recommend that you contact the county clerk if you are unsure what
          documents you might need, as you will be asked to upload them (if any)
          here.
        </Typography>
        <Typography
          type='body-400'
          variant='functional-low'
          className='mt-4 max-w-[436px]'
        >
          Please allow up to 15 business days to receive your requested
          documents.
        </Typography>
        <Button className='mt-8' onClick={handleStart}>
          Start
        </Button>
      </div>
    </Modal>
  );
};

export default PCOInfoModal;
